import React from 'react';
import { Link } from 'react-router-dom';
import './SuccessModal.css';

const SuccessModal = ({ isOpen, onClose, title, message, type = 'success', customActions }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '🎉';
      case 'info':
        return 'ℹ️';
      case 'warning':
        return '⚠️';
      default:
        return '✅';
    }
  };

  const getTitle = () => {
    switch (type) {
      case 'success':
        return 'Success!';
      case 'info':
        return 'Information';
      case 'warning':
        return 'Warning';
      default:
        return title || 'Success!';
    }
  };

  return (
    <div className="success-modal-overlay" onClick={onClose}>
      <div className="success-modal" onClick={(e) => e.stopPropagation()}>
        <div className="success-modal-content">
          {/* Golden Header */}
          <div className="success-modal-header">
            <div className="success-icon">
              {getIcon()}
            </div>
            <h2 className="success-title">{getTitle()}</h2>
          </div>

          {/* Message */}
          <div className="success-message">
            <p>{message}</p>
          </div>

          {/* Golden Divider */}
          <div className="success-divider"></div>

          {/* Actions */}
          <div className="success-actions">
            {customActions ? (
              customActions
            ) : (
              <>
                <button 
                  className="success-btn primary"
                  onClick={onClose}
                >
                  <i className="fas fa-check"></i>
                  Continue Shopping
                </button>
                
                <Link 
                  to="/profile" 
                  className="success-btn secondary"
                  onClick={onClose}
                >
                  <i className="fas fa-user"></i>
                  Go to Profile
                </Link>
              </>
            )}
          </div>

          {/* Close Button */}
          <button 
            className="success-close-btn"
            onClick={onClose}
            aria-label="Close modal"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal; 